import { render, staticRenderFns } from "./Login_JianKang.vue?vue&type=template&id=6595bf2d&scoped=true"
import script from "./Login_JianKang.vue?vue&type=script&lang=js"
export * from "./Login_JianKang.vue?vue&type=script&lang=js"
import style0 from "./Login_JianKang.vue?vue&type=style&index=0&id=6595bf2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6595bf2d",
  null
  
)

export default component.exports